import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
   title?: string;
};

const CheckIcon = ({ title = "Check icon",  ...props}: Props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            role="img"
            aria-label={title}
        >
         <title>{title}</title>
            <path
                d="M5.47164 9.27234L14.241 0.503015C14.4479 0.296069 14.6893 0.192596 14.9653 0.192596C15.2412 0.192596 15.4826 0.296069 15.6896 0.503015C15.8965 0.70996 16 0.955708 16 1.24026C16 1.52481 15.8965 1.77056 15.6896 1.9775L6.19595 11.497C5.98901 11.7039 5.74757 11.8074 5.47164 11.8074C5.19571 11.8074 4.95428 11.7039 4.74733 11.497L0.298002 7.04767C0.0910561 6.84072 -0.00810537 6.59498 0.000517364 6.31043C0.0091401 6.02588 0.116924 5.78013 0.32387 5.57318C0.530816 5.36624 0.776563 5.26276 1.06111 5.26276C1.34566 5.26276 1.59141 5.36624 1.79836 5.57318L5.47164 9.27234Z"
                fill="#EE2B7B"
            />
        </svg>
    );
};

export default CheckIcon;
